<template>
    <span class="text-danger" v-if="mostrarBtnDesassociarDespViagem">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Despesa de Viagem"
            @click.stop="
                confirmarDesassociarDespViagem(
                    finalizacaoDespViagem.finalizacaoDespViagemId
                )
            "
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacaoDespViagem: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociarDespViagem(finalizacaoDespViagemId) {
            this.$swal({
                title: 'Desassociar Despesa de Viagem',
                html: `Confirma a desassociação da despesa de viagem?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarDespViagem(finalizacaoDespViagemId)
                }
            })
        },

        desassociarDespViagem(finalizacaoDespViagemId) {
            this.$store.dispatch('addRequest')
            this.finalizacoesServicos
                .desassociarDespViagem({
                    finalizacaoId: this.$route.params.finalizacaoId,
                    finalizacaoDespViagemId: finalizacaoDespViagemId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFinalizacaoAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar despesa de viagem da finalização.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnDesassociarDespViagem() {
            return (
                (this.finalizacao.status === 0 ||
                    this.finalizacao.status === 5) &&
                this.$temAcesso('CRED-FORN-FIN-03')
            )
        }
    }
}
</script>
